var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _g, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanner4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 372,
    height: 587,
    viewBox: "0 0 372 587",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M326.814 42.7974H48.5859V115.832H326.814V42.7974Z",
    fill: "#1B2F6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M63.1581 108.994H85.043V53.3311H63.1581L63.1581 108.994Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1562 53.3308L85.0411 72.9805V83.5226L63.1562 63.5299V53.3308Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M63.1581 56.4639H85.043V53.3321H63.1581V56.4639Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M288.893 108.994H310.777V53.3311H288.893V108.994Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M288.891 53.3308L310.775 72.9805V83.5226L288.891 63.5299V53.3308Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M288.893 56.4639H310.777V53.3321H288.893V56.4639Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M353.111 113.951H20.6836V586.216H353.111V113.951Z",
    fill: "#1B2F6C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4414 500.406V575.963L93.1158 576.226C93.1158 576.226 93.1114 500.406 93.4282 500.406C93.7451 500.406 63.4414 500.406 63.4414 500.406Z",
    fill: "#263238"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1619 502.417H65.6875V573.686H91.1619V502.417Z",
    fill: "#1B2F6C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M91.1619 502.417H65.6875V573.686H91.1619V502.417Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M91.1619 502.417H65.6875V506.561H91.1619V502.417Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M87.8586 502.417C87.2279 502.417 65.6875 546.043 65.6875 546.043V502.417H87.8586Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M361.261 108.458H11.6992V119.444H361.261V108.458Z",
    fill: "#263238"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M334.535 39.7488H38.5273V50.7355H334.535V39.7488Z",
    fill: "#263238"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M100.871 39.7488H89.5664V586.216H100.871V39.7488Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M313.082 500.406V575.963L342.756 576.226C342.756 576.226 342.752 500.406 343.069 500.406C343.386 500.406 313.082 500.406 313.082 500.406Z",
    fill: "#263238"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M340.799 502.417H315.324V573.686H340.799V502.417Z",
    fill: "#1B2F6C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M340.799 502.417H315.324V573.686H340.799V502.417Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M340.799 502.417H315.324V506.561H340.799V502.417Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M337.495 502.417C336.865 502.417 315.324 546.043 315.324 546.043V502.417H337.495Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M278.883 500.406V575.963L308.557 576.226C308.557 576.226 308.553 500.406 308.87 500.406C309.186 500.406 278.883 500.406 278.883 500.406Z",
    fill: "#263238"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M306.599 502.417H281.125V573.686H306.599V502.417Z",
    fill: "#1B2F6C"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M306.599 502.417H281.125V573.686H306.599V502.417Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M306.599 502.417H281.125V506.561H306.599V502.417Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M303.296 502.417C302.664 502.417 281.125 546.043 281.125 546.043V502.417H303.296Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M284.094 39.6426H272.789V586.214H284.094V39.6426Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M353.27 119.444H342.648V469.092H353.27V119.444Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M31.3056 119.444H20.6836V469.092H31.3056V119.444Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M369.659 193.909H0V204.895H369.659V193.909Z",
    fill: "#263238"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M369.977 282.971H0V293.958H369.977V282.971Z",
    fill: "#263238"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M371.916 372.266H0V383.253H371.916V372.266Z",
    fill: "#263238"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M370.053 462.643H0V473.629H370.053V462.643Z",
    fill: "#263238"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M58.6222 50.7349H48.5859V108.459H58.6222V50.7349Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M326.818 50.7349H316.781V108.459H326.818V50.7349Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M272.936 11.7074H100.871V586.214H272.936V11.7074Z",
    fill: "#1B2F6C"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M310.764 132.367H288.879V188.03H310.764V132.367Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M310.764 132.367L288.879 152.017V162.559L310.764 142.565V132.367Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M310.764 132.367H288.879V135.499H310.764V132.367Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M337.85 132.367H315.965V188.03H337.85V132.367Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M337.85 152.896L315.965 172.546V183.088L337.85 163.095V152.896Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M337.85 132.367H315.965V135.499H337.85V132.367Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M100.432 119.444H20.6836V124.088H100.432V119.444Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M353.279 119.444H273.027V124.088H353.279V119.444Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M325.113 170.628C325.113 178.359 325.113 186.091 325.113 193.822C325.113 194.524 326.203 194.524 326.203 193.822C326.203 186.091 326.203 178.359 326.203 170.628C326.203 169.926 325.113 169.925 325.113 170.628Z",
    fill: "#263238"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M312.598 170.628C312.598 178.359 312.598 186.091 312.598 193.822C312.598 194.524 313.688 194.524 313.688 193.822C313.688 186.091 313.688 178.359 313.688 170.628C313.688 169.926 312.598 169.925 312.598 170.628Z",
    fill: "#263238"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M300.098 170.628C300.098 178.359 300.098 186.091 300.098 193.822C300.098 194.524 301.188 194.524 301.188 193.822C301.188 186.091 301.188 178.359 301.188 170.628C301.188 169.926 300.098 169.924 300.098 170.628Z",
    fill: "#263238"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M287.594 170.628C287.594 178.359 287.594 186.091 287.594 193.822C287.594 194.524 288.684 194.524 288.684 193.822C288.684 186.091 288.684 178.359 288.684 170.628C288.684 169.926 287.594 169.925 287.594 170.628Z",
    fill: "#263238"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M275.082 170.628C275.082 178.359 275.082 186.091 275.082 193.822C275.082 194.524 276.172 194.524 276.172 193.822C276.172 186.091 276.172 178.359 276.172 170.628C276.172 169.926 275.082 169.925 275.082 170.628Z",
    fill: "#263238"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M336.457 170.628C336.457 178.359 336.457 186.091 336.457 193.822C336.457 194.524 337.547 194.524 337.547 193.822C337.547 186.091 337.547 178.359 337.547 170.628C337.547 169.926 336.457 169.925 336.457 170.628Z",
    fill: "#263238"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M347.41 170.628C347.41 178.359 347.41 186.091 347.41 193.822C347.41 194.524 348.5 194.524 348.5 193.822C348.5 186.091 348.5 178.359 348.5 170.628C348.5 169.926 347.41 169.925 347.41 170.628Z",
    fill: "#263238"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M358.641 170.8C358.641 178.532 358.641 186.263 358.641 193.995C358.641 194.697 359.731 194.697 359.731 193.995C359.731 186.263 359.731 178.532 359.731 170.8C359.731 170.098 358.641 170.098 358.641 170.8Z",
    fill: "#263238"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M368.742 193.734C368.742 186.09 368.742 178.445 368.742 170.8C368.742 170.098 367.652 170.098 367.652 170.8C367.652 178.445 367.652 186.09 367.652 193.734C367.652 194.436 368.742 194.438 368.742 193.734Z",
    fill: "#263238"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M274.199 171.173C298.406 171.173 322.615 171.173 346.822 171.173C353.687 171.173 360.552 171.173 367.416 171.173C368.118 171.173 368.118 170.083 367.416 170.083C343.209 170.083 319 170.083 294.793 170.083C287.928 170.083 281.063 170.083 274.199 170.083C273.497 170.083 273.495 171.173 274.199 171.173Z",
    fill: "#263238"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M59.123 188.03H81.0078V132.367H59.123L59.123 188.03Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1211 132.367L81.0059 152.017V162.559L59.1211 142.565V132.367Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M59.123 135.499H81.0078V132.367H59.123V135.499Z",
    fill: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M32.0409 188.03H53.9258L53.9258 132.367H32.0409L32.0409 188.03Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0391 152.896L53.9239 172.546V183.088L32.0391 163.095V152.896Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M32.0409 135.499H53.9258V132.367H32.0409V135.499Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6836 170.628C43.6836 178.359 43.6836 186.091 43.6836 193.822C43.6836 194.524 44.7735 194.524 44.7735 193.822C44.7735 186.091 44.7735 178.359 44.7735 170.628C44.7735 169.926 43.6836 169.925 43.6836 170.628Z",
    fill: "#263238"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1953 170.628C56.1953 178.359 56.1953 186.091 56.1953 193.822C56.1953 194.524 57.2853 194.524 57.2853 193.822C57.2853 186.091 57.2853 178.359 57.2853 170.628C57.2853 169.926 56.1953 169.925 56.1953 170.628Z",
    fill: "#263238"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6992 170.628C68.6992 178.359 68.6992 186.09 68.6992 193.822C68.6992 194.524 69.7892 194.524 69.7892 193.822C69.7892 186.09 69.7892 178.359 69.7892 170.628C69.7892 169.926 68.6992 169.924 68.6992 170.628Z",
    fill: "#263238"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2109 170.628C81.2109 178.359 81.2109 186.091 81.2109 193.822C81.2109 194.524 82.3009 194.524 82.3009 193.822C82.3009 186.091 82.3009 178.359 82.3009 170.628C82.3009 169.926 81.2109 169.925 81.2109 170.628Z",
    fill: "#263238"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7109 170.628C93.7109 178.359 93.7109 186.091 93.7109 193.822C93.7109 194.524 94.8009 194.524 94.8009 193.822C94.8009 186.091 94.8009 178.359 94.8009 170.628C94.8009 169.926 93.7109 169.925 93.7109 170.628Z",
    fill: "#263238"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3359 170.628C32.3359 178.359 32.3359 186.091 32.3359 193.822C32.3359 194.524 33.4259 194.524 33.4259 193.822C33.4259 186.091 33.4259 178.359 33.4259 170.628C33.4259 169.926 32.3359 169.924 32.3359 170.628Z",
    fill: "#263238"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3828 170.628C21.3828 178.359 21.3828 186.091 21.3828 193.822C21.3828 194.524 22.4728 194.524 22.4728 193.822C22.4728 186.091 22.4728 178.359 22.4728 170.628C22.4728 169.926 21.3828 169.924 21.3828 170.628Z",
    fill: "#263238"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1484 170.801C10.1484 178.532 10.1484 186.264 10.1484 193.995C10.1484 194.697 11.2384 194.697 11.2384 193.995C11.2384 186.264 11.2384 178.532 11.2384 170.801C11.2384 170.099 10.1484 170.099 10.1484 170.801Z",
    fill: "#263238"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M2.23449 193.734C2.23449 186.09 2.23449 178.445 2.23449 170.8C2.23449 170.098 1.14453 170.098 1.14453 170.8C1.14453 178.445 1.14453 186.09 1.14453 193.734C1.14453 194.436 2.23449 194.438 2.23449 193.734Z",
    fill: "#263238"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6852 170.083C71.478 170.083 47.2694 170.083 23.0622 170.083C16.1969 170.083 9.33312 170.083 2.46785 170.083C1.76592 170.083 1.76592 171.173 2.46785 171.173C26.675 171.173 50.8837 171.173 75.0909 171.173C81.9561 171.173 88.8199 171.173 95.6852 171.173C96.3871 171.173 96.3886 170.083 95.6852 170.083Z",
    fill: "#263238"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M310.764 221.902H288.879V277.565H310.764V221.902Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M310.764 221.902L288.879 241.552V252.094L310.764 232.101V221.902Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M310.764 221.902H288.879V225.034H310.764V221.902Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M337.85 221.902H315.965V277.565H337.85V221.902Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M337.85 242.432L315.965 262.082V272.624L337.85 252.63V242.432Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M337.85 221.902H315.965V225.033H337.85V221.902Z",
    fill: "black"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M100.432 204.896H20.6836V209.539H100.432V204.896Z",
    fill: "black"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M353.279 204.896H273.027V209.539H353.279V204.896Z",
    fill: "black"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M325.113 260.162C325.113 267.894 325.113 275.625 325.113 283.358C325.113 284.058 326.203 284.06 326.203 283.358C326.203 275.626 326.203 267.895 326.203 260.162C326.203 259.46 325.113 259.46 325.113 260.162Z",
    fill: "#263238"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M312.598 260.162C312.598 267.894 312.598 275.625 312.598 283.358C312.598 284.058 313.688 284.06 313.688 283.358C313.688 275.626 313.688 267.895 313.688 260.162C313.688 259.46 312.598 259.46 312.598 260.162Z",
    fill: "#263238"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M300.098 260.162C300.098 267.894 300.098 275.625 300.098 283.358C300.098 284.058 301.188 284.06 301.188 283.358C301.188 275.626 301.188 267.895 301.188 260.162C301.188 259.46 300.098 259.46 300.098 260.162Z",
    fill: "#263238"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M287.594 260.162C287.594 267.894 287.594 275.625 287.594 283.358C287.594 284.058 288.684 284.06 288.684 283.358C288.684 275.626 288.684 267.895 288.684 260.162C288.684 259.46 287.594 259.46 287.594 260.162Z",
    fill: "#263238"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M275.082 260.162C275.082 267.894 275.082 275.625 275.082 283.358C275.082 284.058 276.172 284.06 276.172 283.358C276.172 275.626 276.172 267.895 276.172 260.162C276.172 259.46 275.082 259.46 275.082 260.162Z",
    fill: "#263238"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M336.457 260.162C336.457 267.894 336.457 275.625 336.457 283.358C336.457 284.058 337.547 284.06 337.547 283.358C337.547 275.626 337.547 267.895 337.547 260.162C337.547 259.46 336.457 259.46 336.457 260.162Z",
    fill: "#263238"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M347.41 260.162C347.41 267.894 347.41 275.625 347.41 283.358C347.41 284.058 348.5 284.06 348.5 283.358C348.5 275.626 348.5 267.895 348.5 260.162C348.5 259.46 347.41 259.46 347.41 260.162Z",
    fill: "#263238"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M358.641 260.335C358.641 268.067 358.641 275.798 358.641 283.53C358.641 284.232 359.731 284.232 359.731 283.53C359.731 275.798 359.731 268.067 359.731 260.335C359.731 259.635 358.641 259.634 358.641 260.335Z",
    fill: "#263238"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M368.742 283.27C368.742 275.625 368.742 267.98 368.742 260.336C368.742 259.634 367.652 259.634 367.652 260.336C367.652 267.98 367.652 275.625 367.652 283.27C367.652 283.972 368.742 283.973 368.742 283.27Z",
    fill: "#263238"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M274.199 260.707C298.406 260.707 322.615 260.707 346.822 260.707C353.687 260.707 360.552 260.707 367.416 260.707C368.118 260.707 368.118 259.617 367.416 259.617C343.209 259.617 319 259.617 294.793 259.617C287.928 259.617 281.063 259.617 274.199 259.617C273.497 259.617 273.495 260.707 274.199 260.707Z",
    fill: "#263238"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M310.764 309.647H288.879V365.311H310.764V309.647Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M310.764 309.647L288.879 329.297V339.841L310.764 319.847V309.647Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M310.764 309.647H288.879V312.779H310.764V309.647Z",
    fill: "black"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M337.85 309.648H315.965V365.311H337.85V309.648Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M337.85 330.178L315.965 349.828V360.37L337.85 340.376V330.178Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M337.85 309.648H315.965V312.78H337.85V309.648Z",
    fill: "black"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M353.279 293.958H273.027V298.601H353.279V293.958Z",
    fill: "black"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M325.113 348.856C325.113 356.587 325.113 364.319 325.113 372.052C325.113 372.754 326.203 372.754 326.203 372.052C326.203 364.32 326.203 356.589 326.203 348.856C326.203 348.156 325.113 348.154 325.113 348.856Z",
    fill: "#263238"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M312.598 348.856C312.598 356.587 312.598 364.319 312.598 372.052C312.598 372.754 313.688 372.754 313.688 372.052C313.688 364.32 313.688 356.589 313.688 348.856C313.688 348.156 312.598 348.154 312.598 348.856Z",
    fill: "#263238"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M300.098 348.856C300.098 356.588 300.098 364.319 300.098 372.052C300.098 372.754 301.188 372.754 301.188 372.052C301.188 364.321 301.188 356.589 301.188 348.856C301.188 348.156 300.098 348.154 300.098 348.856Z",
    fill: "#263238"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M287.594 348.856C287.594 356.587 287.594 364.319 287.594 372.052C287.594 372.754 288.684 372.754 288.684 372.052C288.684 364.32 288.684 356.589 288.684 348.856C288.684 348.156 287.594 348.154 287.594 348.856Z",
    fill: "#263238"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M275.082 348.856C275.082 356.587 275.082 364.319 275.082 372.052C275.082 372.754 276.172 372.754 276.172 372.052C276.172 364.32 276.172 356.589 276.172 348.856C276.172 348.156 275.082 348.154 275.082 348.856Z",
    fill: "#263238"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M336.457 348.856C336.457 356.587 336.457 364.319 336.457 372.052C336.457 372.754 337.547 372.754 337.547 372.052C337.547 364.32 337.547 356.589 337.547 348.856C337.547 348.156 336.457 348.154 336.457 348.856Z",
    fill: "#263238"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M347.41 348.856C347.41 356.587 347.41 364.319 347.41 372.052C347.41 372.754 348.5 372.754 348.5 372.052C348.5 364.32 348.5 356.589 348.5 348.856C348.5 348.156 347.41 348.154 347.41 348.856Z",
    fill: "#263238"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M358.641 349.03C358.641 356.762 358.641 364.493 358.641 372.224C358.641 372.926 359.731 372.926 359.731 372.224C359.731 364.493 359.731 356.762 359.731 349.03C359.731 348.328 358.641 348.327 358.641 349.03Z",
    fill: "#263238"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M368.742 371.965C368.742 364.321 368.742 356.675 368.742 349.031C368.742 348.329 367.652 348.329 367.652 349.031C367.652 356.675 367.652 364.321 367.652 371.965C367.652 372.665 368.742 372.667 368.742 371.965Z",
    fill: "#263238"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M274.199 349.401C298.406 349.401 322.615 349.401 346.822 349.401C353.687 349.401 360.552 349.401 367.416 349.401C368.118 349.401 368.118 348.311 367.416 348.311C343.209 348.311 319 348.311 294.793 348.311C287.928 348.311 281.063 348.311 274.199 348.311C273.497 348.311 273.495 349.401 274.199 349.401Z",
    fill: "#263238"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M62.8222 273.867H84.707V218.204H62.8222L62.8222 273.867Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8203 218.205L84.7037 237.855V248.397L62.8203 228.402V218.205Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M62.8222 221.337H84.707V218.205H62.8222V221.337Z",
    fill: "black"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M35.7402 273.867H57.625L57.625 218.204H35.7402L35.7402 273.867Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7383 238.734L57.6217 258.383V268.925L35.7383 248.933V238.734Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M35.7402 221.337H57.625V218.205H35.7402V221.337Z",
    fill: "black"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6836 260.162C43.6836 267.894 43.6836 275.625 43.6836 283.358C43.6836 284.058 44.7735 284.06 44.7735 283.358C44.7735 275.626 44.7735 267.895 44.7735 260.162C44.7735 259.46 43.6836 259.46 43.6836 260.162Z",
    fill: "#263238"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1953 260.162C56.1953 267.894 56.1953 275.625 56.1953 283.358C56.1953 284.058 57.2853 284.06 57.2853 283.358C57.2853 275.626 57.2853 267.895 57.2853 260.162C57.2853 259.46 56.1953 259.46 56.1953 260.162Z",
    fill: "#263238"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6992 260.162C68.6992 267.894 68.6992 275.625 68.6992 283.358C68.6992 284.058 69.7892 284.06 69.7892 283.358C69.7892 275.626 69.7892 267.895 69.7892 260.162C69.7892 259.46 68.6992 259.46 68.6992 260.162Z",
    fill: "#263238"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2109 260.162C81.2109 267.894 81.2109 275.625 81.2109 283.358C81.2109 284.058 82.3009 284.06 82.3009 283.358C82.3009 275.626 82.3009 267.895 82.3009 260.162C82.3009 259.46 81.2109 259.46 81.2109 260.162Z",
    fill: "#263238"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7109 260.162C93.7109 267.894 93.7109 275.625 93.7109 283.358C93.7109 284.058 94.8009 284.06 94.8009 283.358C94.8009 275.626 94.8009 267.895 94.8009 260.162C94.8009 259.46 93.7109 259.46 93.7109 260.162Z",
    fill: "#263238"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3359 260.162C32.3359 267.894 32.3359 275.625 32.3359 283.358C32.3359 284.058 33.4259 284.06 33.4259 283.358C33.4259 275.626 33.4259 267.895 33.4259 260.162C33.4259 259.46 32.3359 259.46 32.3359 260.162Z",
    fill: "#263238"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3828 260.162C21.3828 267.894 21.3828 275.625 21.3828 283.358C21.3828 284.058 22.4728 284.06 22.4728 283.358C22.4728 275.626 22.4728 267.895 22.4728 260.162C22.4728 259.46 21.3828 259.46 21.3828 260.162Z",
    fill: "#263238"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1484 260.335C10.1484 268.067 10.1484 275.798 10.1484 283.53C10.1484 284.232 11.2384 284.232 11.2384 283.53C11.2384 275.798 11.2384 268.067 11.2384 260.335C11.2384 259.635 10.1484 259.634 10.1484 260.335Z",
    fill: "#263238"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M2.23449 283.269C2.23449 275.625 2.23449 267.98 2.23449 260.335C2.23449 259.633 1.14453 259.633 1.14453 260.335C1.14453 267.98 1.14453 275.625 1.14453 283.269C1.14453 283.971 2.23449 283.973 2.23449 283.269Z",
    fill: "#263238"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6852 259.617C71.478 259.617 47.2694 259.617 23.0622 259.617C16.1969 259.617 9.33312 259.617 2.46785 259.617C1.76592 259.617 1.76592 260.707 2.46785 260.707C26.675 260.707 50.8837 260.707 75.0909 260.707C81.9561 260.707 88.8199 260.707 95.6852 260.707C96.3871 260.707 96.3886 259.617 95.6852 259.617Z",
    fill: "#263238"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M100.432 293.631H20.6836V298.274H100.432V293.631Z",
    fill: "black"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M62.8222 362.603H84.707V306.94H62.8222L62.8222 362.603Z",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8203 306.94L84.7037 326.59V337.132L62.8203 317.138V306.94Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M62.8222 310.072H84.707V306.94H62.8222V310.072Z",
    fill: "black"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M35.7402 362.603H57.625L57.625 306.94H35.7402L35.7402 362.603Z",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7383 327.469L57.6217 347.119V357.662L35.7383 337.668V327.469Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M35.7402 310.072H57.625V306.94H35.7402V310.072Z",
    fill: "black"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M62.8222 451.727H84.707V396.064H62.8222L62.8222 451.727Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8203 396.065L84.7037 415.715V426.257L62.8203 406.263V396.065Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M62.8222 399.196H84.707V396.064H62.8222V399.196Z",
    fill: "black"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M35.7402 451.727H57.625L57.625 396.064H35.7402L35.7402 451.727Z",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7383 416.594L57.6217 436.244V446.786L35.7383 426.792V416.594Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M35.7402 399.196H57.625V396.064H35.7402V399.196Z",
    fill: "black"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6836 348.898C43.6836 356.629 43.6836 364.361 43.6836 372.092C43.6836 372.794 44.7735 372.794 44.7735 372.092C44.7735 364.361 44.7735 356.629 44.7735 348.898C44.7735 348.197 43.6836 348.196 43.6836 348.898Z",
    fill: "#263238"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1953 348.898C56.1953 356.629 56.1953 364.361 56.1953 372.092C56.1953 372.794 57.2853 372.794 57.2853 372.092C57.2853 364.361 57.2853 356.629 57.2853 348.898C57.2853 348.197 56.1953 348.196 56.1953 348.898Z",
    fill: "#263238"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6992 348.898C68.6992 356.629 68.6992 364.361 68.6992 372.092C68.6992 372.794 69.7892 372.794 69.7892 372.092C69.7892 364.361 69.7892 356.629 69.7892 348.898C69.7892 348.197 68.6992 348.196 68.6992 348.898Z",
    fill: "#263238"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2109 348.898C81.2109 356.629 81.2109 364.361 81.2109 372.092C81.2109 372.794 82.3009 372.794 82.3009 372.092C82.3009 364.361 82.3009 356.629 82.3009 348.898C82.3009 348.197 81.2109 348.196 81.2109 348.898Z",
    fill: "#263238"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7109 348.898C93.7109 356.629 93.7109 364.361 93.7109 372.092C93.7109 372.794 94.8009 372.794 94.8009 372.092C94.8009 364.361 94.8009 356.629 94.8009 348.898C94.8009 348.197 93.7109 348.196 93.7109 348.898Z",
    fill: "#263238"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3359 348.897C32.3359 356.629 32.3359 364.36 32.3359 372.092C32.3359 372.794 33.4259 372.794 33.4259 372.092C33.4259 364.36 33.4259 356.629 33.4259 348.897C33.4259 348.197 32.3359 348.196 32.3359 348.897Z",
    fill: "#263238"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3828 348.897C21.3828 356.629 21.3828 364.36 21.3828 372.092C21.3828 372.794 22.4728 372.794 22.4728 372.092C22.4728 364.36 22.4728 356.629 22.4728 348.897C22.4728 348.197 21.3828 348.196 21.3828 348.897Z",
    fill: "#263238"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1484 349.072C10.1484 356.803 10.1484 364.535 10.1484 372.267C10.1484 372.968 11.2384 372.969 11.2384 372.267C11.2384 364.536 11.2384 356.805 11.2384 349.072C11.2384 348.37 10.1484 348.368 10.1484 349.072Z",
    fill: "#263238"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M2.23449 372.006C2.23449 364.362 2.23449 356.716 2.23449 349.072C2.23449 348.37 1.14453 348.37 1.14453 349.072C1.14453 356.716 1.14453 364.362 1.14453 372.006C1.14453 372.707 2.23449 372.708 2.23449 372.006Z",
    fill: "#263238"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6852 348.352C71.478 348.352 47.2694 348.352 23.0622 348.352C16.1969 348.352 9.33312 348.352 2.46785 348.352C1.76592 348.352 1.76592 349.442 2.46785 349.442C26.675 349.442 50.8837 349.442 75.0909 349.442C81.9561 349.442 88.8199 349.442 95.6852 349.442C96.3871 349.442 96.3886 348.352 95.6852 348.352Z",
    fill: "#263238"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M310.764 400.327H288.879V455.991H310.764V400.327Z",
    fill: "white"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M310.764 400.327L288.879 419.977V430.519L310.764 410.525V400.327Z",
    fill: "white"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M310.764 400.327H288.879V403.459H310.764V400.327Z",
    fill: "black"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M337.85 400.327H315.965V455.991H337.85V400.327Z",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M337.85 420.856L315.965 440.506V451.048L337.85 431.054V420.856Z",
    fill: "white"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M337.85 400.327H315.965V403.459H337.85V400.327Z",
    fill: "black"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M353.279 383.253H273.027V387.896H353.279V383.253Z",
    fill: "black"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M325.113 439.536C325.113 447.267 325.113 454.998 325.113 462.731C325.113 463.433 326.203 463.433 326.203 462.731C326.203 455 326.203 447.268 326.203 439.536C326.203 438.834 325.113 438.832 325.113 439.536Z",
    fill: "#263238"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M312.598 439.536C312.598 447.267 312.598 454.998 312.598 462.731C312.598 463.433 313.688 463.433 313.688 462.731C313.688 455 313.688 447.268 313.688 439.536C313.688 438.834 312.598 438.832 312.598 439.536Z",
    fill: "#263238"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M300.098 439.535C300.098 447.267 300.098 454.998 300.098 462.731C300.098 463.433 301.188 463.433 301.188 462.731C301.188 455 301.188 447.268 301.188 439.535C301.188 438.833 300.098 438.832 300.098 439.535Z",
    fill: "#263238"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M287.594 439.536C287.594 447.267 287.594 454.998 287.594 462.731C287.594 463.433 288.684 463.433 288.684 462.731C288.684 455 288.684 447.268 288.684 439.536C288.684 438.834 287.594 438.832 287.594 439.536Z",
    fill: "#263238"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M275.082 439.536C275.082 447.267 275.082 454.998 275.082 462.731C275.082 463.433 276.172 463.433 276.172 462.731C276.172 455 276.172 447.268 276.172 439.536C276.172 438.834 275.082 438.832 275.082 439.536Z",
    fill: "#263238"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M336.457 439.536C336.457 447.267 336.457 454.998 336.457 462.731C336.457 463.433 337.547 463.433 337.547 462.731C337.547 455 337.547 447.268 337.547 439.536C337.547 438.834 336.457 438.832 336.457 439.536Z",
    fill: "#263238"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M347.41 439.536C347.41 447.267 347.41 454.998 347.41 462.731C347.41 463.433 348.5 463.433 348.5 462.731C348.5 455 348.5 447.268 348.5 439.536C348.5 438.834 347.41 438.832 347.41 439.536Z",
    fill: "#263238"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M358.641 439.708C358.641 447.44 358.641 455.171 358.641 462.902C358.641 463.604 359.731 463.604 359.731 462.902C359.731 455.171 359.731 447.44 359.731 439.708C359.731 439.006 358.641 439.006 358.641 439.708Z",
    fill: "#263238"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M368.742 462.643C368.742 454.998 368.742 447.353 368.742 439.709C368.742 439.007 367.652 439.007 367.652 439.709C367.652 447.353 367.652 454.998 367.652 462.643C367.652 463.345 368.742 463.345 368.742 462.643Z",
    fill: "#263238"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M274.199 440.08C298.406 440.08 322.615 440.08 346.822 440.08C353.687 440.08 360.552 440.08 367.416 440.08C368.118 440.08 368.118 438.99 367.416 438.99C343.209 438.99 319 438.99 294.793 438.99C287.928 438.99 281.063 438.99 274.199 438.99C273.497 438.99 273.495 440.08 274.199 440.08Z",
    fill: "#263238"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M100.432 383.253H20.6836V387.896H100.432V383.253Z",
    fill: "black"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6836 439.578C43.6836 447.309 43.6836 455.041 43.6836 462.772C43.6836 463.474 44.7735 463.474 44.7735 462.772C44.7735 455.041 44.7735 447.309 44.7735 439.578C44.7735 438.876 43.6836 438.874 43.6836 439.578Z",
    fill: "#263238"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1953 439.578C56.1953 447.309 56.1953 455.041 56.1953 462.772C56.1953 463.474 57.2853 463.474 57.2853 462.772C57.2853 455.041 57.2853 447.309 57.2853 439.578C57.2853 438.876 56.1953 438.874 56.1953 439.578Z",
    fill: "#263238"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6992 439.578C68.6992 447.309 68.6992 455.04 68.6992 462.772C68.6992 463.474 69.7892 463.474 69.7892 462.772C69.7892 455.04 69.7892 447.309 69.7892 439.578C69.7892 438.876 68.6992 438.874 68.6992 439.578Z",
    fill: "#263238"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2109 439.578C81.2109 447.309 81.2109 455.041 81.2109 462.772C81.2109 463.474 82.3009 463.474 82.3009 462.772C82.3009 455.041 82.3009 447.309 82.3009 439.578C82.3009 438.876 81.2109 438.874 81.2109 439.578Z",
    fill: "#263238"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7109 439.578C93.7109 447.309 93.7109 455.041 93.7109 462.772C93.7109 463.474 94.8009 463.474 94.8009 462.772C94.8009 455.041 94.8009 447.309 94.8009 439.578C94.8009 438.876 93.7109 438.874 93.7109 439.578Z",
    fill: "#263238"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3359 439.578C32.3359 447.309 32.3359 455.04 32.3359 462.772C32.3359 463.474 33.4259 463.474 33.4259 462.772C33.4259 455.04 33.4259 447.309 33.4259 439.578C33.4259 438.876 32.3359 438.874 32.3359 439.578Z",
    fill: "#263238"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3828 439.578C21.3828 447.309 21.3828 455.04 21.3828 462.772C21.3828 463.474 22.4728 463.474 22.4728 462.772C22.4728 455.04 22.4728 447.309 22.4728 439.578C22.4728 438.876 21.3828 438.874 21.3828 439.578Z",
    fill: "#263238"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1484 439.751C10.1484 447.482 10.1484 455.214 10.1484 462.945C10.1484 463.647 11.2384 463.647 11.2384 462.945C11.2384 455.214 11.2384 447.482 11.2384 439.751C11.2384 439.049 10.1484 439.049 10.1484 439.751Z",
    fill: "#263238"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M2.23449 462.684C2.23449 455.04 2.23449 447.395 2.23449 439.75C2.23449 439.048 1.14453 439.048 1.14453 439.75C1.14453 447.395 1.14453 455.04 1.14453 462.684C1.14453 463.386 2.23449 463.386 2.23449 462.684Z",
    fill: "#263238"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M100.725 439.033C75.0167 439.033 49.3083 439.033 23.5999 439.033C16.5559 439.033 9.51187 439.033 2.46785 439.033C1.76592 439.033 1.76592 440.123 2.46785 440.123C28.1763 440.123 53.8847 440.123 79.5931 440.123C86.6371 440.123 93.6811 440.123 100.725 440.123C101.426 440.123 101.427 439.033 100.725 439.033Z",
    fill: "#263238"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7891 86.7635C55.7891 94.4949 55.7891 102.226 55.7891 109.958C55.7891 110.66 56.879 110.66 56.879 109.958C56.879 102.226 56.879 94.4949 56.879 86.7635C56.879 86.063 55.7891 86.0615 55.7891 86.7635Z",
    fill: "#263238"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3008 86.7635C68.3008 94.4949 68.3008 102.226 68.3008 109.958C68.3008 110.66 69.3907 110.66 69.3907 109.958C69.3907 102.226 69.3907 94.4949 69.3907 86.7635C69.3907 86.063 68.3008 86.0615 68.3008 86.7635Z",
    fill: "#263238"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8008 86.7635C80.8008 94.4949 80.8008 102.226 80.8008 109.958C80.8008 110.66 81.8907 110.66 81.8907 109.958C81.8907 102.226 81.8907 94.4949 81.8907 86.7635C81.8907 86.063 80.8008 86.0615 80.8008 86.7635Z",
    fill: "#263238"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3164 86.7635C93.3164 94.4949 93.3164 102.226 93.3164 109.958C93.3164 110.66 94.4064 110.66 94.4064 109.958C94.4064 102.226 94.4064 94.4949 94.4064 86.7635C94.4064 86.063 93.3164 86.0615 93.3164 86.7635Z",
    fill: "#263238"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4414 86.7632C44.4414 94.4946 44.4414 102.226 44.4414 109.957C44.4414 110.659 45.5314 110.659 45.5314 109.957C45.5314 102.226 45.5314 94.4946 45.5314 86.7632C45.5314 86.0627 44.4414 86.0613 44.4414 86.7632Z",
    fill: "#263238"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4883 86.7632C33.4883 94.4946 33.4883 102.226 33.4883 109.957C33.4883 110.659 34.5782 110.659 34.5782 109.957C34.5782 102.226 34.5782 94.4946 34.5782 86.7632C34.5782 86.0627 33.4883 86.0613 33.4883 86.7632Z",
    fill: "#263238"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2578 86.9358C22.2578 94.6672 22.2578 102.399 22.2578 110.13C22.2578 110.832 23.3478 110.832 23.3478 110.13C23.3478 102.399 23.3478 94.6672 23.3478 86.9358C23.3478 86.2353 22.2578 86.2339 22.2578 86.9358Z",
    fill: "#263238"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M14.34 109.87C14.34 102.226 14.34 94.5806 14.34 86.9364C14.34 86.2344 13.25 86.2344 13.25 86.9364C13.25 94.5806 13.25 102.226 13.25 109.87C13.25 110.572 14.34 110.574 14.34 109.87Z",
    fill: "#263238"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M100.87 86.218C78.7572 86.218 56.6427 86.218 34.5297 86.218C27.8781 86.218 21.225 86.218 14.5733 86.218C13.8714 86.218 13.8714 87.308 14.5733 87.308C36.9959 87.308 59.417 87.308 81.8395 87.308C88.1831 87.308 94.5266 87.308 100.87 87.308C101.571 87.308 101.572 86.218 100.87 86.218Z",
    fill: "#263238"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M317.234 86.7635C317.234 94.4949 317.234 102.226 317.234 109.958C317.234 110.66 318.324 110.66 318.324 109.958C318.324 102.226 318.324 94.4949 318.324 86.7635C318.324 86.063 317.234 86.0615 317.234 86.7635Z",
    fill: "#263238"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M304.73 86.7635C304.73 94.4949 304.73 102.226 304.73 109.958C304.73 110.66 305.82 110.66 305.82 109.958C305.82 102.226 305.82 94.4949 305.82 86.7635C305.82 86.063 304.73 86.0615 304.73 86.7635Z",
    fill: "#263238"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M292.219 86.7635C292.219 94.4949 292.219 102.226 292.219 109.958C292.219 110.66 293.309 110.66 293.309 109.958C293.309 102.226 293.309 94.4949 293.309 86.7635C293.309 86.063 292.219 86.0615 292.219 86.7635Z",
    fill: "#263238"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M279.707 86.7635C279.707 94.4949 279.707 102.226 279.707 109.958C279.707 110.66 280.797 110.66 280.797 109.958C280.797 102.226 280.797 94.4949 280.797 86.7635C280.797 86.063 279.707 86.0615 279.707 86.7635Z",
    fill: "#263238"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M328.582 86.7635C328.582 94.4949 328.582 102.226 328.582 109.958C328.582 110.66 329.672 110.66 329.672 109.958C329.672 102.226 329.672 94.4949 329.672 86.7635C329.672 86.063 328.582 86.0615 328.582 86.7635Z",
    fill: "#263238"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M339.535 86.7635C339.535 94.4949 339.535 102.226 339.535 109.958C339.535 110.66 340.625 110.66 340.625 109.958C340.625 102.226 340.625 94.4949 340.625 86.7635C340.625 86.063 339.535 86.0615 339.535 86.7635Z",
    fill: "#263238"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M350.77 86.9358C350.77 94.6672 350.77 102.399 350.77 110.13C350.77 110.832 351.859 110.832 351.859 110.13C351.859 102.399 351.859 94.6672 351.859 86.9358C351.859 86.2353 350.77 86.2339 350.77 86.9358Z",
    fill: "#263238"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M360.863 109.87C360.863 102.226 360.863 94.5803 360.863 86.9361C360.863 86.2342 359.773 86.2342 359.773 86.9361C359.773 94.5803 359.773 102.226 359.773 109.87C359.773 110.572 360.863 110.574 360.863 109.87Z",
    fill: "#263238"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M273.246 87.308C295.359 87.308 317.473 87.308 339.586 87.308C346.238 87.308 352.891 87.308 359.543 87.308C360.245 87.308 360.245 86.218 359.543 86.218C337.12 86.218 314.699 86.218 292.276 86.218C285.933 86.218 279.589 86.218 273.246 86.218C272.544 86.218 272.542 87.308 273.246 87.308Z",
    fill: "#263238"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M262.399 11.8195H106.18V469.091H262.399V11.8195Z",
    fill: "white"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M106.18 349.123H138.826V295.356H186.476V238.785V134.402H232.469V204.15H262.399V469.092H106.18V349.123Z",
    fill: "black"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M264.975 239.44L106.938 351.814V399.312L264.975 287.449V239.44Z",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M264.216 307.527L106.18 419.902V435.953L264.216 327.469V307.527Z",
    fill: "white"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M262.399 80.2966L106.18 192.671V208.721L262.399 100.238V80.2966Z",
    fill: "white"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M273.088 12.0928H100.875V18.5991H273.088V12.0928Z",
    fill: "black"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M104.124 122.808C145.724 122.808 187.324 122.808 228.922 122.808C240.773 122.808 252.623 122.808 264.475 122.808C265.177 122.808 265.177 121.718 264.475 121.718C222.875 121.718 181.276 121.718 139.676 121.718C127.825 121.718 115.975 121.718 104.124 121.718C103.423 121.718 103.422 122.808 104.124 122.808Z",
    fill: "#1B2F6C"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M103.573 172.356C146.404 172.356 189.235 172.356 232.065 172.356C243.949 172.356 255.832 172.356 267.716 172.356C268.418 172.356 268.418 171.266 267.716 171.266C224.885 171.266 182.054 171.266 139.223 171.266C127.34 171.266 115.456 171.266 103.573 171.266C102.872 171.266 102.871 172.356 103.573 172.356Z",
    fill: "#1B2F6C"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M104.367 221.902C146.929 221.902 189.491 221.902 232.052 221.902C243.939 221.902 255.827 221.902 267.714 221.902C268.415 221.902 268.415 220.812 267.714 220.812C225.152 220.812 182.589 220.812 140.029 220.812C128.141 220.812 116.253 220.812 104.366 220.812C103.665 220.812 103.664 221.902 104.367 221.902Z",
    fill: "#1B2F6C"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M103.617 271.448C146.438 271.448 189.258 271.448 232.077 271.448C243.959 271.448 255.841 271.448 267.723 271.448C268.425 271.448 268.425 270.358 267.723 270.358C224.903 270.358 182.082 270.358 139.263 270.358C127.381 270.358 115.499 270.358 103.617 270.358C102.915 270.358 102.913 271.448 103.617 271.448Z",
    fill: "#1B2F6C"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M103.617 320.996C146.438 320.996 189.258 320.996 232.077 320.996C243.959 320.996 255.841 320.996 267.723 320.996C268.425 320.996 268.425 319.906 267.723 319.906C224.903 319.906 182.082 319.906 139.263 319.906C127.381 319.906 115.499 319.906 103.617 319.906C102.915 319.906 102.913 320.996 103.617 320.996Z",
    fill: "#1B2F6C"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M107.362 370.543C148.962 370.543 190.56 370.543 232.16 370.543C244.012 370.543 255.862 370.543 267.713 370.543C268.415 370.543 268.415 369.453 267.713 369.453C226.113 369.453 184.515 369.453 142.915 369.453C131.063 369.453 119.213 369.453 107.362 369.453C106.661 369.453 106.66 370.543 107.362 370.543Z",
    fill: "#1B2F6C"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M107.362 420.089C148.962 420.089 190.56 420.089 232.16 420.089C244.012 420.089 255.862 420.089 267.713 420.089C268.415 420.089 268.415 418.999 267.713 418.999C226.113 418.999 184.515 418.999 142.915 418.999C131.063 418.999 119.213 418.999 107.362 418.999C106.661 418.999 106.66 420.089 107.362 420.089Z",
    fill: "#1B2F6C"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M104.124 72.4369C146.693 72.4369 189.262 72.4369 231.831 72.4369C243.795 72.4369 255.757 72.4369 267.72 72.4369C268.422 72.4369 268.422 71.3469 267.72 71.3469C225.151 71.3469 182.581 71.3469 140.012 71.3469C128.049 71.3469 116.087 71.3469 104.124 71.3469C103.423 71.3469 103.422 72.4369 104.124 72.4369Z",
    fill: "#1B2F6C"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M155.637 10.4739C155.637 70.0203 155.637 129.565 155.637 189.112C155.637 248.354 155.637 307.596 155.637 366.838C155.637 400.256 155.637 433.676 155.637 467.094C155.637 467.796 156.727 467.796 156.727 467.094C156.727 407.548 156.727 348.003 156.727 288.456C156.727 229.213 156.727 169.972 156.727 110.729C156.727 77.3114 156.727 43.8919 156.727 10.4739C156.727 9.77342 155.637 9.77197 155.637 10.4739Z",
    fill: "#1B2F6C"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M214.66 10.4738C214.66 70.0202 214.66 129.565 214.66 189.112C214.66 248.354 214.66 307.596 214.66 366.838C214.66 400.256 214.66 433.676 214.66 467.094C214.66 467.796 215.75 467.796 215.75 467.094C215.75 407.547 215.75 348.002 215.75 288.456C215.75 229.213 215.75 169.972 215.75 110.729C215.75 77.3113 215.75 43.8918 215.75 10.4738C215.75 9.7733 214.66 9.77185 214.66 10.4738Z",
    fill: "#1B2F6C"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M353.111 486.729H20.6836V494.106H353.111V486.729Z",
    fill: "black"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M226.753 497.273H142.105V586.216H226.753V497.273Z",
    fill: "#263238"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2266 500.406V575.963L58.901 576.226C58.901 576.226 58.8966 500.406 59.2134 500.406C59.5302 500.406 29.2266 500.406 29.2266 500.406Z",
    fill: "#263238"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9432 502.417H31.4688V573.686H56.9432V502.417Z",
    fill: "#1B2F6C"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M56.9432 502.417H31.4688V573.686H56.9432V502.417Z",
    fill: "white"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M56.9432 502.417H31.4688V506.561H56.9432V502.417Z",
    fill: "black"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M53.6399 502.417C53.0092 502.417 31.4688 546.043 31.4688 546.043V502.417H53.6399Z",
    fill: "white"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M182.611 500.75H145.859V582.737H182.611V500.75Z",
    fill: "#1B2F6C"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M222.995 500.75H187.145V582.737H222.995V500.75Z",
    fill: "#1B2F6C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.611 500.75H145.859V582.737H182.611V500.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M145.859 535.843H157.523V550.76H166.008C166.008 550.76 166.467 582.737 166.008 582.737C165.548 582.737 145.861 582.737 145.861 582.737L145.859 535.843Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.995 500.75H187.145V582.737H222.995V500.75Z",
    fill: "white"
  }))), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M223 500.75H145.863V505.996H223V500.75Z",
    fill: "black"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M145.863 548.301C145.863 548.301 182.615 510.696 182.615 511.385C182.615 512.072 182.615 534.085 182.615 534.085L145.863 573.754V548.301Z",
    fill: "white"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M186.766 548.301C186.766 548.301 222.997 510.696 222.997 511.385C222.997 512.072 222.997 534.085 222.997 534.085L186.766 573.754V548.301Z",
    fill: "white"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M123.118 490.417H106.438V586.214H123.118V490.417Z",
    fill: "#263238"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M123.146 490.66H106.438V492.005H123.146V490.66Z",
    fill: "black"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M125.401 483.988H104.16V490.66H125.401V483.988Z",
    fill: "#263238"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M125.401 487.323H104.16V488.668H125.401V487.323Z",
    fill: "black"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M268.388 490.979H251.707V586.216H268.388V490.979Z",
    fill: "#263238"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M268.408 490.66H251.699V492.005H268.408V490.66Z",
    fill: "black"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M270.667 483.988H249.426V490.66H270.667V483.988Z",
    fill: "#263238"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M270.663 487.323H249.422V488.668H270.663V487.323Z",
    fill: "black"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M353.271 473.125H20.6875V487.511H353.271V473.125Z",
    fill: "#263238"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M223.001 560.626H207.121V582.737H223.001V560.626Z",
    fill: "black"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M279.221 0H93.7344V12.0927H279.221V0Z",
    fill: "#263238"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M100.721 50.7349H48.5859V54.0425H100.721V50.7349Z",
    fill: "black"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M326.82 50.7349H273.121V54.0425H326.82V50.7349Z",
    fill: "black"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M189.632 541.744H179.223V561.642H189.632V541.744Z",
    fill: "#263238"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M273.439 438.249H100.727V475.88H273.439V438.249Z",
    fill: "#263238"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M142.017 447.368V468.136H136.142V460.037H128.132V468.136H122.258V447.368H128.132V455.171H136.142V447.368H142.017Z",
    fill: "#1B2F6C"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M151.039 457.752C151.039 451.522 155.934 446.953 162.58 446.953C169.225 446.953 174.12 451.522 174.12 457.752C174.12 463.983 169.225 468.552 162.58 468.552C155.935 468.552 151.039 463.983 151.039 457.752ZM168.188 457.752C168.188 454.163 165.724 451.819 162.58 451.819C159.435 451.819 156.973 454.163 156.973 457.752C156.973 461.342 159.436 463.686 162.58 463.686C165.726 463.686 168.188 461.342 168.188 457.752Z",
    fill: "#1B2F6C"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M187.273 452.026H180.895V447.368H199.496V452.026H193.147V468.136H187.273V452.026Z",
    fill: "#1B2F6C"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M224.306 463.596V468.136H207.633V447.368H223.921V451.907H213.449V455.408H222.676V459.798H213.449V463.596H224.306Z",
    fill: "#1B2F6C"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M233.504 447.368H239.378V463.478H249.288V468.136H233.504V447.368Z",
    fill: "#1B2F6C"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M253.264 449.561C253.985 449.561 254.57 448.977 254.57 448.255C254.57 447.533 253.985 446.948 253.264 446.948C252.542 446.948 251.957 447.533 251.957 448.255C251.957 448.977 252.542 449.561 253.264 449.561Z",
    fill: "#1B2F6C"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M256.849 449.561C257.571 449.561 258.156 448.977 258.156 448.255C258.156 447.533 257.571 446.948 256.849 446.948C256.128 446.948 255.543 447.533 255.543 448.255C255.543 448.977 256.128 449.561 256.849 449.561Z",
    fill: "#1B2F6C"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M260.435 449.561C261.157 449.561 261.742 448.977 261.742 448.255C261.742 447.533 261.157 446.948 260.435 446.948C259.714 446.948 259.129 447.533 259.129 448.255C259.129 448.977 259.714 449.561 260.435 449.561Z",
    fill: "#1B2F6C"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M264.025 449.561C264.747 449.561 265.332 448.977 265.332 448.255C265.332 447.533 264.747 446.948 264.025 446.948C263.304 446.948 262.719 447.533 262.719 448.255C262.719 448.977 263.304 449.561 264.025 449.561Z",
    fill: "#1B2F6C"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9048 474.548C65.2066 474.548 108.507 474.548 151.809 474.548C194.988 474.548 238.169 474.548 281.349 474.548C305.661 474.548 329.973 474.548 354.283 474.548C354.985 474.548 354.985 473.458 354.283 473.458C310.981 473.458 267.681 473.458 224.379 473.458C181.2 473.458 138.018 473.458 94.8388 473.458C70.527 473.458 46.2166 473.458 21.9048 473.458C21.2043 473.458 21.2029 474.548 21.9048 474.548Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner4);
export default __webpack_public_path__ + "static/media/banner4.ab378e114e3ee8e5da02afaa4e542890.svg";
export { ForwardRef as ReactComponent };